import { EmployeeDto, OnboardingPeriodDto } from '@zorro/clients';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { CardSelector } from '../../CardSelector';
import { getPaymentMethodSelectOptions } from './paymentMethodType.consts';

type PaymentMethodTypeProps = {
  employeeId: EmployeeDto['id'];
  onboardingPeriodId: OnboardingPeriodDto['id'];
  isElena?: boolean;
};

export const PaymentMethodType = ({
  employeeId,
  onboardingPeriodId,
  isElena = false,
}: PaymentMethodTypeProps) => {
  const {
    data: paymentMethodDetails,
    isLoading: isLoadingPaymentMethodDetails,
  } = useMonolithQuery({
    method: 'paymentsControllerEmployeePaymentMethodDetails',
    params: [employeeId, { onboardingPeriodId }],
  });

  if (isLoadingPaymentMethodDetails || !paymentMethodDetails) {
    return null;
  }

  return (
    <CardSelector
      selectData={getPaymentMethodSelectOptions(isElena)}
      selectedValue={paymentMethodDetails.type}
      isReadOnly
    />
  );
};
